module.exports = __webpack_public_path__ + "static/media/n.4a2074e1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/n.mp3
// module id = 103
// module chunks = 0